@if (quote() !== undefined && quote().volume !== undefined) {
  @if (isSessionAfterOpen()) {
    <span [innerText]="quote().volume | tdWbNumber: { shorten: true }"></span>
  }
  @if (isSessionBeforeOpen()) {
    <span>-</span>
  }
  @if (quote().volumePace !== undefined) {
    (@if (isSessionBeforeOpen()) {
      <span class="td-wb-quote-volume-contextual-help__link">-</span>
    } @else {
      <span class="td-wb-quote-volume-contextual-help__link">
      <a role="button"
         tabindex="0"
         href=""
         [innerText]="link"
         [tdWbOverlayToggle]="quoteVolumeContextHelpOverlay"
         tdWbOverlayPosition="end-bottom"
         tdWbOverlaySize="small">
      </a>
    </span>
      <ng-template #quoteVolumeContextHelpOverlay>
        <td-wb-overlay>
          <td-wb-overlay-header [title]="'tdWb.markets.quote.CLOSE' | tdWbTranslate" />
          <ng-container *ngTemplateOutlet="quote().sessionIsActive ? sessionActiveVolume : sessionInactiveVolume" />
        </td-wb-overlay>
      </ng-template>
    })
  }
}


<ng-template #sessionActiveVolume>
  <span class="td-wb-quote-volume-contextual-help__body"
        [innerHTML]="body"></span>
</ng-template>
<ng-template #sessionInactiveVolume>
  <div>
    <span translate="tdWb.markets.quote.volumecontextualhelp.VOLUME"></span>:&nbsp;
    <span [innerText]="quote().volume | tdWbNumber: { format: 'n0' }"></span>
  </div>
  <div>
    <span translate="tdWb.markets.quote.volumecontextualhelp.TEN_DAY_AVERAGE_VOLUME"></span>:
    <span [innerText]="quote().volumeTenDays | tdWbNumber: { format: 'n0' }"></span>
  </div>
</ng-template>
